<script>
  import _base from '../../_default/components/_base.vue'
  import PMenu from './components/Menu.vue'
  import PregaoMenuStats from './components/Stats'
  import LoteLeilaoStats from './components/LoteLeilaoStats'
  import LoteInfo from './components/LoteInfo'
  import HistoricoLances from './components/HistoricoLances'
  import ILanceManual from './components/InputLanceManual'
  import IAlterarIncremento from './components/InputAlterarIncremento'
  import IAlterarTimer from './components/InputAlterarTimer'
  import ChatComitenteResumido from './components/ChatResumidoComitente'
  import UKeyboard from './components/Keyboard'
  import { findIndex as _findIndex, merge as _merge } from 'lodash'
  // import { Status as SocketStatus } from '../../../domain/leiloes/helpers/SocketStatus'
  import * as Status from '../../../domain/leiloes/helpers/LoteStatus'
  import { number_format as numberFormat } from '../../../utils/helpers/phpjs'
  import ChangeStatus from './components/ChangeStatus.vue'
  import Service from '../../../domain/leiloes/services/pregao'
  import Comunicator from 'rogeriomenezes-comunicator'
  import ACL from '../../../domain/acl/tmp-acl'
  import { mapGetters } from 'vuex'
  import IContraproposta from './components/InputContraproposta'

  export default {
    name: 'Pregao',
    extends: _base,
    data () {
      return {
        isComConnected: 0,
        leilao: {},
        pregao: null,
        lote: {
          numero: 0,
          imagem: null,
          descricao: '-',
          valorInicial: 0.00,
          valorIncremento: 0.00,
          valorMinimo: 0.00,
          valorMeta: 0.00,
          lancePrincipal: null,
          status: null,
          comitente: {
            pessoa: {}
          },
          pregao: null,
          lances: []
        },
        stats: {
          arrematantesOnline: 0,
          espectadoresOnline: 0,
          comitentesOnline: 0
        },
        isLoading: false,
        centerContentFolded: false,
        loteAnterior: 0
      }
    },
    created () {
      this.$loaderOverlay.open().message('Aguarde enquanto carregamos o leilão')
      Service.find(this.$route.params.id)
        .then((response) => {
          this.$loaderOverlay.hide()
          this.isLoading = false
          this.leilao = response.data.leilao
          if (typeof this.leilao['timerPregao'] !== 'undefined') {
            this.$refs.painelLote.updateDefaultTimerPregao(this.leilao['timerPregao'])
          }
          this.lote = response.data.lote
          this.pregao = response.data.pregao
          if (this.pregao !== null) {
            window.setTimeout(() => {
              this.centerContentFolded = true
              this.$refs.keyboard.toggleKeyboard()
              this.$refs.painelLote.mountTimerCountdown()
            }, 500)
          }
        })
        .catch((response) => {
          this.$loaderOverlay.hide()
          // window.alert('Erro ao carregar o pregão. Tente novamente, caso o erro persista, contate o administrador do sistema.')
          window.responseError(response)
          console.log(response)
        })
    },
    computed: {
      classLanceOnline () {
        if (typeof this.lote.lancePrincipal !== 'undefined' && this.lote.lancePrincipal !== null && this.lote.lancePrincipal !== 'null') {
          if (this.lote.lancePrincipal.arrematante.apelido !== 'PLATEIA') {
            console.log('A1')
            return ['dash-pregao-online']
          }
          console.log('A2')
          return ['']
        }
        console.log('A3')
        return ['']
      },
      ACL () {
        return ACL
      },
      ...mapGetters(['currentUser'])
    },
    mounted () {
      if (!this.ACL.check('controlar_leilao', this.currentUser.id)) {
        alert('Sem permissão de acesso')
        this.$router.push('/')
        return
      }
      /* Realtime Comunicator */
      // this.wsChannel = 'pregao/' + this.$route.params.id
      this.comunicator = Comunicator.connect(process.env.WS_URL)
      this.comunicator.on('lance', this.onLance)
      this.comunicator.on('status', this.onStatus)
      this.comunicator.on('statusLeilao', this.onStatusLeilao)
      this.comunicator.on('tempo', this.onTempo)
      this.comunicator.on('mudaLote', this.onMudaLote)
      this.comunicator.on('lanceDeletado', this.onLanceDeletado)
      this.comunicator.on('alteracaoIncremento', this.onAlteracaoIncremento)
      this.comunicator.on('alteracaoTempo', this.onAlteracaoTempo)
      this.comunicator.on('comitenteDecisaoStatusLote', this.onComitenteDecisaoStatusLote)
      this.comunicator.on('com/connect', (env) => {
        this.isComConnected = 1
      })
      this.comunicator.on('com/disconnect', (env) => {
        this.isComConnected = 2
      })
      window.setTimeout(() => {
        if (this.isComConnected !== 1) {
          this.isComConnected = 2 // No connection alert
        }
      }, 4000)
      /* End */

      this._showMenu(false)
      this._showHeader(true)
      this._showFooter(false)
      this._menuFolded(false)
      this.$nextTick(() => {
        this.$root.$el.classList.add('full-height')
      })
    },
    destroyed () {
      this.$root.$el.classList.remove('full-height')
      if (this.comunicator) {
        console.log('Saindo da tela realtime')
        this.comunicator.close()
      }
    },
    methods: {
      onLance: function (data) {
        if (!(this.validateComunication(data) && this.validateComunicationLote(data))) {
          return
        }
        this.novoLance({id: data.lote.id, status: data.lote.status, lancePrincipal: data.lote.lance}, data.lote.lance)
      },
      onStatus: function (data) {
        // nothing to do
        this.mudaStatus(data)
      },
      onStatusLeilao: function (data) {
        // nothing to do
      },
      onTempo: function (data) {
        // nothing to do
        this.renovaTempo({date: data.lote.tempo})
      },
      onMudaLote: function (data) {
        // nothing to do
      },
      onLanceDeletado: function (data) {
        // nothing to do
      },
      onAlteracaoIncremento: function (data) {
        // nothing to do
      },
      onAlteracaoTempo: function (data) {
        // nothing to do
      },
      onComitenteDecisaoStatusLote: function (data) {
        console.log(data) // TODO: Fazer notificação
      },
      validateComunication: function (event) {
        if (typeof event['leilao'] === 'undefined') {
          return false
        }
        if (typeof event['leilao']['id'] !== 'undefined') {
          return event['leilao']['id'] === this.leilao.id
        }
        return event['leilao'] === this.leilao.id
      },
      validateComunicationLote: function (event) {
        if (typeof event['lote'] === 'undefined') {
          return false
        }
        if (typeof event.lote['id'] === 'undefined') {
          if (event.lote === this.lote.id) {
            return true
          }
        } else {
          if (event.lote.id === this.lote.id) {
            return true
          }
        }
        return false
      },
      toggleKeyboard (v) {
        this.centerContentFolded = v
      },
      abrirPregao () {
        this.$loaderOverlay.open().message('Abrindo Pregão')
        Service.abrir(this.$route.params.id)
          .then((response) => {
            this.$loaderOverlay.hide()
            this.isLoading = false
            this.leilao = response.data.leilao
            this.lote = response.data.lote
            this.pregao = response.data.pregao
            window.setTimeout(() => {
              this.centerContentFolded = true
              this.$refs.keyboard.toggleKeyboard()
            }, 100)
            // this.ws.transmiteMensagem(this.wsChannel, SocketStatus.LEILAO_ABERTO)
          })
          .catch((response) => {
            this.$loaderOverlay.hide()
            window.alert('Erro ao abrir o pregão. Tente novamente, caso o erro persista, contate o administrador do sistema.')
            console.log(response)
          })
      },
      mudarLote ({acao, lote, pregao}) {
        if (acao !== 'trocar') {
          this.loteAnterior = this.lote.numero
        }
        this.lote = lote
        this.pregao = pregao
        this.reset()
        // this.ws.transmiteMensagem(this.wsChannel, SocketStatus.LOTE_ALTERADO)
      },
      deletarLance (lance) {
        this.lote.lances.splice(_findIndex(this.lote.lances, lance), 1)
        Service.getLancePrincipal(this.lote.id)
          .then((response) => {
            if (response.data.lote === this.lote.id) {
              this.lote.lancePrincipal = response.data.lancePrincipal
            } else {
              console.log('Lance deletado porém o lote não é o mesmo na tela')
            }
          })
          .catch((response) => {
            window.responseError(response)
            console.log(response)
          })
        // ws
      },
      homologar () {
        if (this.lote.status === Status.STATUS_EM_PREGAO) {
          this.$refs.keyboard.updateLoteStatus(Status.STATUS_HOMOLOGANDO, this.lote.id)
        }
      },
      statusLote (lote) {
        delete this.lote.pregao
        _merge(this.lote, lote)
        this.$refs.painelLote.mountTimerCountdown()
        // ws
      },
      novoLance (lote, lance) {
        // Verifica se o lote que recebeu o lance é o mesmo ativo na view
        if (lote.id !== this.lote.id) {
          return
        }
        _merge(this.lote, lote)
        this.lote.lances.unshift(lance)
        this.$refs.painelLote.mountTimerCountdown()
        this.$refs.painelLote.novoLance()
        // ws
      },
      lanceManual (valor) {
        // Pré-validação (Se lance for igual ou menor que o último lance atual, não pode continuar
        this.$refs.keyboard.lanceManual(valor)
        this.$refs.keyboard.focusMe()
      },
      alterarIncremento (valor) {
        this.$confirm.open('Tem certeza que deseja alterar o incremento mínimo do lote para ' + numberFormat(valor, 2, ',', '.') + '?', 'Alterar', 'Cancelar', null, (v) => {
          if (v === false) {
            return
          }
          console.log('Trocando incremento mínimo para ' + valor + '...')
          this.$refs.changeStatus.open('Alterando incremento do lote')
          Service.alteraIncrementoMinimo(this.$route.params.id, this.lote.id, valor)
            .then((response) => {
              this.$refs.changeStatus.close()
              this.lote.valorIncremento = response.data.lote.valorIncremento
              // this.ws.transmiteMensagem(this.wsChannel, _merge(SocketStatus.LOTE_ALTERADO, {bind: {lote: this.lote.id}}))
              this.$emit('incrementoLote', response.data.lote)
            })
            .catch((response) => {
              this.$refs.changeStatus.close()
              window.responseError(response)
              console.log(response)
            })
        })
        this.$refs.keyboard.focusMe()
      },
      contraproposta (valor) {
        this.$confirm.open('Tem certeza que deseja enviar uma contraproposta para os arrematantes no valor de ' + numberFormat(valor, 2, ',', '.') + '?', 'Confirmar', 'Cancelar', null, (v) => {
          if (v === false) {
            return
          }
          console.log('Enviando contraproposta no valor de ' + valor + '...')
          this.$refs.changeStatus.open('Enviando contraproposta')
          Service.contraproposta(this.$route.params.id, this.lote.id, valor)
            .then((response) => {
              this.$refs.changeStatus.close()
              this.lote.valorIncremento = response.data.lote.valorIncremento
              // this.ws.transmiteMensagem(this.wsChannel, _merge(SocketStatus.LOTE_ALTERADO, {bind: {lote: this.lote.id}}))
              this.$emit('contraproposta', response.data.lote)
            })
            .catch((response) => {
              this.$refs.changeStatus.close()
              window.responseError(response)
              console.log(response)
            })
        })
        this.$refs.keyboard.focusMe()
      },
      alterarTimer (valor) {
        this.$confirm.open('Tem certeza que deseja alterar o tempo do pregão para ' + valor + ' segundos?', 'Alterar', 'Cancelar', null, (v) => {
          if (v === false) {
            return
          }
          console.log('Trocando tempo do pregão para ' + valor + ' segundos...')
          this.$refs.changeStatus.open('Alterando tempo do pregão')
          Service.alteraTimer(this.$route.params.id, valor)
            .then((response) => {
              this.$refs.changeStatus.close()
              this.leilao.timerPregao = response.data.timer
              this.reajustaTimerPregao(response.data.timer)
              // this.ws.transmiteMensagem(this.wsChannel, _merge(SocketStatus.LEILAO_TIMER_ALTERADO, {bind: {leilao: this.leilao.id}}))
            })
            .catch((response) => {
              this.$refs.changeStatus.close()
              window.responseError(response)
              console.log(response)
            })
        })
        this.$refs.keyboard.focusMe()
      },
      reajustaTimerPregao (newTimer) {
        this.$refs.painelLote.updateDefaultTimerPregao(newTimer)
        console.log('Reajustando timer do pregão')
      },
      reset () {
        this.$refs.painelLote.mountTimerCountdown()
      },
      renovaTempo (v) {
        /* this.ws.transmiteMensagem(this.wsChannel, _merge(SocketStatus.LOTE_RENOVAR_TEMPO, {
          bind: {
            leilao: this.leilao.id,
            data: v.date
          }
        })) */
        if (this.lote.pregao !== null) {
          this.lote.pregao.dataAbertura = v.date
          if (this.lote.lances.length > 0) {
            this.lote.lances[0].data = v.date
          }
          this.$nextTick(() => {
            this.$refs.painelLote.mountTimerCountdown()
          })
        }
      },
      mudaStatus (data) {
        if (data.lote.id === this.lote.id) {
          if (this.lote.status !== data.lote.status && Number(data.lote.status) === 2) {
            this.lote.status = data.lote.status
            this.$refs.keyboard.updateLoteStatus(data.lote.status, data.lote.id)
          }
        }
      }
    },
    components: {
      IContraproposta,
      UKeyboard,
      ChatComitenteResumido,
      IAlterarIncremento,
      IAlterarTimer,
      ILanceManual,
      HistoricoLances,
      LoteInfo,
      LoteLeilaoStats,
      PregaoMenuStats,
      PMenu,
      ChangeStatus
    }
  }
</script>

<template>
  <div class="h-full" :class="classLanceOnline">
    <change-status ref="changeStatus"></change-status>
    <div class="pregao" :class="{'show-keyboard': centerContentFolded, 'isLoading': isLoading}">

      <p-menu></p-menu>
      <pregao-menu-stats @abrirPregao="abrirPregao" :pregao="pregao" :leilao="leilao" :loteAnterior="loteAnterior"
                         :stats="stats"></pregao-menu-stats>

      <lote-leilao-stats ref="painelLote" :lote="lote" :leilao="leilao" @homologar="homologar"></lote-leilao-stats>

      <div class="content-center">
        <lote-info :lote="lote"></lote-info>
        <div class="manager-lances">
          <historico-lances :lote="lote"></historico-lances>
          <div class="lance-actions">
            <i-lance-manual @lanceManual="lanceManual"></i-lance-manual>
            <i-alterar-incremento @alterarIncremento="alterarIncremento"></i-alterar-incremento>
            <i-contraproposta @contraproposta="contraproposta"></i-contraproposta>
            <i-alterar-timer @alterarTimer="alterarTimer"></i-alterar-timer>
            <chat-comitente-resumido :com-connected="isComConnected"></chat-comitente-resumido>
          </div>
        </div>
      </div>

      <u-keyboard
        @mudarLote="mudarLote"
        @statusLote="statusLote"
        @deletarLance="deletarLance"
        @novoLance="novoLance"
        ref="keyboard"
        :startShow="centerContentFolded"
        @toggle="toggleKeyboard"
        @renovaTempo="renovaTempo"></u-keyboard>

    </div>
  </div>
</template>

<style lang="scss" src="./assets/scss/default.scss"></style>



// WEBPACK FOOTER //
// Main.vue?5d9c4329